<template>
<div v-show="isModalVisible">
    <div class="modal-mask" @click="closeModal">
        <div class="modal-container" @click.stop>
            <!-- Modal Header -->
            <div class=""></div>
            <!-- Modal body -->
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
                <h5 class="modal-title" ref="modalTitle" style="border-bottom: 1px solid #C8C7C8; padding-bottom: 5px;">{{ taskListTitle }}</h5>
                <div class="task_count">{{ remainingCount + ' Tasks Remaining' }}</div>
                <div class="row subtask-wrapper bg-grey" v-for="(remainingTask, rindex) in remainingTasks" :key="rindex">
                    <div class="col-12 parent-heading"> 
                      {{ remainingTask.parent_heading }}
                    </div>
                    <div class="col-12" v-for="(heading, hindex) in remainingTask.headings" :key="hindex">
                        <div class="heading_name" style="border-bottom: 1px solid #C8C7C8;">{{ heading.heading_name }}</div>
                        <div v-for="(task, tindex) in heading.tasks" :key="tindex">
                            <div class="remaining-task">{{ task.description }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import router from '../../router/index.js';

export default {
  props: [
    'isModalVisible',
    'tasklistId',
    ],
  data() {
    return {
        remainingCount: 0,
        remainingTasks: [],
        taskListTitle: '',
    }
  },
  components: {
  },
  methods: {
    closeModal() {
      this.remainingTasks = [];
      this.$emit('close');
    },
    getTaskItem(remainingCount, remainingIds, pathwayId) {
        this.remainingCount = remainingCount;
        axios('/mobile/report-overview-remaining-tasks-competency-report',
            {
            method: 'POST',
            data: {
                "remaining_ids": remainingIds,
                "pathwayId": pathwayId,
            } 
        })
        .then(response =>  {
            this.remainingTasks = response.data.remainingTasks;
            this.taskListTitle = response.data.pathwayName;  
        })
        .catch(() => {
            console.log("error comes")
        });
    },
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
}
.modal-container { 
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 820px;
  padding: 20px 30px;
  background-color: #FFF;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  color: #002F42;
}
.modal-body {
  margin: 0px;
  padding: 10px;
  height: 620px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 13px !important;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #002F42;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.modal-title {
  color: #002F42;
  font-size: 14px;
  font-weight: 900;
}
.modal-body {
  padding: 5px;
}
.task_count {
  font-size: 14px;
  margin: 10px 0;
  border-bottom: 0px solid #A6A6A6;
  padding-bottom: 15px;
  font-style: italic;
}
.bottom-line-sep {  
  border-bottom: 2px solid #A6A6A6;
  padding-bottom: 15px;
  padding-top: 15px;
  margin-bottom: 15px;
}
.parent-heading {
  font-weight: 900;
}
.heading_name {
  font-weight: 900;
  margin: 10px;
}
.remaining-task {
  background-color: #FFF;
  border: 1px solid #FFF;
  border-radius: 10px;
  margin: 10px;
  padding: 10px;
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;    
  }
}
.subtask-wrapper {
  border: 1px solid #C8C7C8;
  background-color: #FFF;
  float: left;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 5px;
  margin-left: 1px;
  padding-top: 10px;
}
.bg-grey {
  background-color: #F0F0F0;
}

</style>



// WEBPACK FOOTER //
// src/components/manager/overview_remaining_tasks.vue